export const humanizeEnum = (val: string, capitilize = true) => {
  if (!val) {
    return '';
  }
  let r = val.replace(/[_-]/g, ' '); // change dashes & underscores to spaces
  r = r.replace(/(\/)/g, ' / '); // add spaces around slashes
  r = r.replace(/([A-Z][a-z])/g, ($1) => ` ${$1}`); // prepend spaces before Words
  r = r.replace(/([A-Z]+)/g, ($1) => ` ${$1}`).toLowerCase(); // prepend space before STUFF
  r = r.trim();
  if (capitilize) {
    r = r.replace(/^(.)|\s(.)/g, ($1) => $1.toUpperCase()); // capitilize first letters
  }
  r = r.replace(/\s+/g, ' '); // remove double whitespaces
  return r;
};

export const enumizeString = (val: string) => {
  if (!val) {
    return '';
  }
  let r = val.toLowerCase();
  r = r.replace(/ /g, '_');
  r = r.replace(/(\/)/g, '_');
  return r;
};

export const humanizeBool = (val: boolean) => (val ? 'Yes' : 'No');

export const humanizeValue = (value: unknown): string | null => {
  // Handle null explicitly - return dash as visual indicator
  if (value === null) {
    return '-';
  }

  switch (typeof value) {
    case 'undefined':
      // Return null so React renders nothing for missing values
      return null;
    case 'boolean':
      return humanizeBool(value);
    case 'string':
      return value;
    case 'number':
      return value.toString();
    case 'object':
      if (Array.isArray(value)) {
        return value.map(String).join(', ');
      }
      return <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{JSON.stringify(value, null, 2)}</pre>
    default:
      // Fallback for any other types
      return value?.toString() ?? '';
  }
};
